import styled from '@emotion/styled';

export const MainItemsList = styled.ul``;

export const SecondaryItemsList = styled(MainItemsList)``;

export const StyledNavigationBar = styled.nav`
  grid-template-rows: min-content min-content auto min-content 0;
  grid-template-areas:
    'logo'
    'mainItems'
    '.'
    'secondaryItems'
    '.';
  width: var(--navigation-bar-width);
  height: 100%;
  overflow: hidden;
  display: grid;
  background-color: var(--color-core-primary);

  ${MainItemsList}, ${SecondaryItemsList} {
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: grid;
    width: 100%;
  }

  .logo-wrapper {
    grid-area: logo;
    display: flex;
    height: var(--header-height);
    align-items: center;
    justify-content: center;

    svg {
      width: 32px;
      fill: var(--color-state-active);
    }
  }

  ${MainItemsList} {
    grid-area: mainItems;
    margin-bottom: auto;

    ::before {
      content: ' ';
      background-color: var(--color-core-white);
      width: calc(100% - 8px);
      height: 1px;
      margin: 0 auto;
      display: block;
    }
  }

  ${SecondaryItemsList} {
    grid-area: secondaryItems;

    ::before {
      content: ' ';
      background-color: var(--color-core-white);
      width: calc(100% - 8px);
      height: 1px;
      margin: 0 auto;
      display: block;
    }
  }
`;
